export default "__VITE_ASSET__fb02ad6d__"